export const SHOW_HIDE_SNACKBAR = "SHOW_HIDE_SNACKBAR";
export const SHOW_NOTIFICATIONS_SUPPORT_ALERT =
  "SHOW_NOTIFICATIONS_SUPPORT_ALERT";
